module.exports = __webpack_public_path__ + "static/media/clock3.d0799afd.png";